/**
 * The admin's top-level sections, in one place.
 *
 * The nav renders from this, and so does the "back to…" label on any page
 * reached from a list. Keeping both off one definition is what stops a link
 * offering to return you somewhere by a name the nav no longer uses.
 */
export interface Section {
  path: string
  /** How the nav shows it — short, because it sits in a bar. */
  label: string
  /** The page's own heading, which is what a "back to…" link should say. */
  title: string
  /** Whether the path should match exactly. Only the index route needs it. */
  end?: boolean
}

export const SECTIONS: Section[] = [
  { path: '/', label: 'Calendar', title: 'the calendar', end: true },
  { path: '/status', label: 'Status', title: 'Status' },
  { path: '/series', label: 'Series', title: 'Series' },
  { path: '/tracks', label: 'Circuits', title: 'Circuits' },
  { path: '/vendors/ris', label: 'RIS', title: 'RIS Timing' },
  { path: '/vendors/tsl', label: 'TSL', title: 'TSL Timing' },
]

/**
 * Names the section a path belongs to.
 *
 * Falls back to the calendar, because an unrecognised path means somebody
 * arrived by a route we did not anticipate — a bookmark, a refresh, a pasted
 * link — and the whole catalogue is the one destination that is never wrong.
 */
export function sectionTitle(path: string | undefined): string {
  const hit = SECTIONS.find((s) => (s.end ? path === s.path : path?.startsWith(s.path)))
  return hit?.title ?? 'the calendar'
}
